import { render } from "./PlanBundleTabsView.vue?vue&type=template&id=2cde494c&ts=true"
import script from "./PlanBundleTabsView.vue?vue&type=script&lang=ts"
export * from "./PlanBundleTabsView.vue?vue&type=script&lang=ts"

import "./PlanBundleTabsView.vue?vue&type=style&index=0&id=2cde494c&lang=css"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__